import React, { useState } from 'react';
import DatePicker from "react-datepicker";
import { Field } from 'react-final-form';
import "react-datepicker/dist/react-datepicker.css";

import { FormFeedback } from './index';
import './FormDateInput.css';
import { isValid } from 'date-fns';


const renderDateInput = ({ input, meta, inputOnChange, screenDimensions, ...datePickerProps }) => {
  const dateInputProps = {
    ...input,
    ...datePickerProps,
    value: new Date(input.value),
    onChange: e => {
      input.onChange(e);
      inputOnChange && inputOnChange(e);
    }
  }

  return (
    <div>
      <DatePicker
        {...dateInputProps}
        className="form-input__control time-input"
        selected={isValid(new Date(dateInputProps.value)) ? new Date(dateInputProps.value) : ''}
        withPortal={screenDimensions.width <= 1023 ? true : false}
        dateFormat="h:mm aa"
        showTimeSelect
        showTimeSelectOnly
      />

      {meta.submitError && !meta.modifiedSinceLastSubmit && (
        <FormFeedback positive={false}>
          {meta.submitError}
        </FormFeedback>
      )}
      {meta.error && meta.dirty && (
        <FormFeedback positive={false}>
          {meta.error}
        </FormFeedback>
      )}
    </div>
  )
}

export default props => {
  const {
    name,
    initialValue,
    validate,
    labelRenderer,
    ...datePickerProps
  } = props;

  const [date, setDate] = useState(initialValue || new Date());

  const screenDimensions = {
    width: window.innerWidth,
    height: window.innerHeight
  };

  const handleChange = e => {
    if (e && e.date) {
      setDate(e.date);
    }
  }

  return (
    <div>
      <label
        className="form-input"
      >
        {typeof labelRenderer === 'function' && labelRenderer()}
      </label>
      <Field 
        {...datePickerProps}
        name={name}
        initialValue={date}
        component={renderDateInput}
        screenDimensions={screenDimensions}
        inputOnChange={handleChange}
        validate={validate}
      />
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/form/FormTimeInput.js